import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../AppContext";
import { DataContext } from "../DataContext";
import $data from "../../services/$data";
import { Card, CardContent, CircularProgress, Container, Divider, Grid, List, ListItem, ListItemButton, ListItemSecondaryAction, ListItemText, Paper, Stack, Step, StepLabel, Stepper, Typography } from "@mui/material";
import WidgetTitle from "../widgets/WidgetTitle";
import WidgetDescription from "../widgets/WidgetDescription";
import { variables } from "../../styles/abstract/variables";
import FieldInformation from "../carbon-calculator/FieldInformation";
import ResiduesForm from "./residues/ResiduesForm";
import PesticidesForm from "./pesticides/PesticidesForm";
import SoilForm from "./soil/SoilForm";
import AnimalsForm from "./animals/AnimalsForm";
import FuelForm from "./fuel/FuelForm";
import FertilizersForm from "./fertilizers/FertilizersForm";
import IrrigationForm from "./irrigation/IrrigationForm";
import CarbonAssessmentResult from "./CarbonAssessmentResult";
function CarbonAssessmentInput(props) {
  const { selected, onUpdateState } = useContext(AppContext);
  const { projects, projectData, onGetParcels } = useContext(DataContext);
  const [tables, setTables] = useState({})
  const [loading, setLoading] = useState(true);
  const [step, setStep] = useState(1);
  const [parcels, setParcels] = useState([])
  let project = null;

  const isEdit = props.id !== 'new';

  try {
    project = projects.results.find((project) => project.id.toString() === props.project);
  } catch {

  }


  const [fullModel, setFullModel] = useState({
    project_id: project.id,
    project_name: project.name,
    parcel_id: undefined,
    name: '',
    country: {},
    area: 0,
    year: props.year !== 'new' ? parseInt(props.year) : 2025,
    crop: '',
    climateZone: undefined,
    residues: {
      management: 'burned',
      amountBurned: undefined,
      amountLeft: undefined,
      amountN: 1.5,
      totalEmission: undefined,
    },
    pesticides: {
      records: [],
      totalEmission: undefined
    },
    fertilizers: {
      records: [],
      totalEmission: undefined
    },
    animals: {
      records: [],
      totalEmission: undefined
    },
    soil: {
      socChange: undefined,
      ratio: 1 / 10,
      totalEmission: undefined
    },
    fuel: {
      isDirect: true,
      direct: [],
      estimated: [],
      totalEmission: undefined
    },
    irrigation: {
      isDirect: true,
      records: [],
      direct: [],
      estimated: [],
      totalEmission: undefined,

    }
  });

  const onUpdateFullModel = (newModel) => {
    setFullModel(current => {
      return { ...current, ...newModel }
    });
  }

  const getCountry = async (parcel) => {
    try {
      let country = await $data.getCountryForParcel(parcel);
      onUpdateFullModel({ country: country });

    } catch (e) {
      console.log(e)
    }
  }

  const getAssessment = async (projectId) => {
    setLoading(true);
    try {
      let data = await $data.getCCRecord(props.id);
      console.log(data)
      setFullModel(data)
      setLoading(false);
    } catch (error) {
      console.error("Error fetching assessments:", error);
      setLoading(false);
    }
  }

  const getProjectData = async () => {
    if (Boolean(selected)) {
      if (!Boolean(projectData.hasOwnProperty(selected))) {
        onUpdateState({ selected: props.project })
        await onGetParcels();
      }
    } else {
      onUpdateState({ selected: props.project })
      await onGetParcels();
    }

    let parcelList = [...projectData[props.project].parcels];
    setParcels(parcelList)
    let parcel = parcelList.find(p => p.id.toString() === props.parcel);
    if (parcel) {
      let country = await getCountry(parcel);
      let climateZone = await $data.getClimateZoneForParcel(parcel);
      onUpdateFullModel({ parcel_id: parseInt(props.parcel), name: parcel.name, area: parcel.area, country: country, crop: parcel.history[parcel.history.length - 1]?.crop, climateZone })
    }

    let tables = await $data.getFertiliserTables();
    console.log(tables)
    setTables(tables);

    setLoading(false);
  }
  const getTotalEmission = (model) => {
    let total = 0;

    total += model?.residues?.totalEmission || 0;

    total += model?.pesticides?.totalEmission || 0;

    total += model?.fertilizers?.totalEmission || 0;

    total += model?.animals.totalEmission || 0;

    total += model?.fuel.totalEmission || 0;

    total += model?.irrigation.totalEmission || 0;

    if (total === 0) {
      return ' - ';
    }
    
    if(total >= 1000) {
      return <>{(total/1000).toFixed(2)} t CO<sub>2</sub></>
    }
    
    total = <>{total.toFixed(0)} kg CO<sub>2</sub></>
    
    

    return total;
  }

  const getSingleEmission = (val) => {
    if (!val) return ' - ';
    // if(val > 999) {
    //   return <>{(val/1000).toFixed(0)} t CO<sub>2</sub></>
    // }

    if(val >= 1000) {
      return <>{(val/1000).toFixed(2)} t CO<sub>2</sub></>
    }
    
    return <>{val.toFixed(0)} kg CO<sub>2</sub></>
  }

  useEffect(() => {
    getProjectData();
    if (isEdit) {
      getAssessment(props.projectId);
    }
  }, []);

  return (
    <Container sx={{ mt: '30px', pb: '30px' }}>
      <Grid container spacing={2}>

        <Grid item xs={12}>
          <Paper sx={{ padding: '10px' }} className="co-background">
            <WidgetTitle text="Carbon Calculator" />
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <Stack className="only-laptop" direction="row" alignItems="center" justifyContent="space-between">
            <WidgetDescription text="" />
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <Divider color="primary" light style={{ background: variables.primary, height: '3px' }} />
        </Grid>

        <Grid item xs={12}>
          <Paper sx={{ width: 'calc(100% - 20px)', m: '0 auto', padding: '10px' }} className="co-background">
            <Stepper orientation="horizontal" activeStep={step - 1} alternativeLabel>
              <Step>
                <StepLabel onClick={() => setStep(1)} sx={{ cursor: 'pointer !important', '* span': { fontSize: '20px !important' } }}>Field Information</StepLabel>
              </Step>
              <Step>
                <StepLabel onClick={() => setStep(2)} sx={{ cursor: 'pointer !important', '* span': { fontSize: '20px !important' } }}>Residues</StepLabel>
              </Step>
              <Step>
                <StepLabel onClick={() => setStep(3)} sx={{ cursor: 'pointer !important', '* span': { fontSize: '20px !important' } }}>Plant Protection</StepLabel>
              </Step>
              <Step>
                <StepLabel onClick={() => setStep(4)} sx={{ cursor: 'pointer !important', '* span': { fontSize: '20px !important' } }}>Fertilizers</StepLabel>
              </Step>
              <Step>
                <StepLabel onClick={() => setStep(5)} sx={{ cursor: 'pointer !important', '* span': { fontSize: '20px !important' } }}>Animals</StepLabel>
              </Step>
              {/* <Step>
                <StepLabel onClick={() => setStep(6)} sx={{ cursor: 'pointer !important', '* span': { fontSize: '20px !important' } }}>Soil</StepLabel>
              </Step> */}
              <Step>
                <StepLabel onClick={() => setStep(6)} sx={{ cursor: 'pointer !important', '* span': { fontSize: '20px !important' } }}>Fuel & Energy</StepLabel>
              </Step>
              <Step>
                <StepLabel onClick={() => setStep(7)} sx={{ cursor: 'pointer !important', '* span': { fontSize: '20px !important' } }}>Irrigation</StepLabel>
              </Step>
              <Step>
                <StepLabel onClick={() => setStep(8)} sx={{ cursor: 'pointer !important', '* span': { fontSize: '20px !important' } }}>Result</StepLabel>
              </Step>
            </Stepper>
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <Card elevation={5} style={{ borderRadius: 0, background: 'transparent' }}>
                <CardContent className="co-background" sx={{ padding: '10px' }}>
                  <Typography sx={{ padding: '10px' }} fontWeight="bold" variant="h5">Total emission: {getTotalEmission(fullModel)}</Typography>
                  <List dense>
                    <ListItemButton onClick={() => setStep(2)}>
                      <ListItemText primary="Residues" primaryTypographyProps={{ variant: 'h6' }}  ></ListItemText>
                      <ListItemSecondaryAction>{getSingleEmission(fullModel.residues.totalEmission)}</ListItemSecondaryAction>
                    </ListItemButton>

                    <ListItemButton onClick={() => setStep(3)}>
                      <ListItemText primary="Plant Protection" primaryTypographyProps={{ variant: 'h6' }}  ></ListItemText>
                      <ListItemSecondaryAction>{getSingleEmission(fullModel.pesticides.totalEmission)}</ListItemSecondaryAction>
                    </ListItemButton>

                    <ListItemButton onClick={() => setStep(4)}>
                      <ListItemText primary="Fertilizers" primaryTypographyProps={{ variant: 'h6' }}  ></ListItemText>
                      <ListItemSecondaryAction>{getSingleEmission(fullModel.fertilizers.totalEmission)}</ListItemSecondaryAction>
                    </ListItemButton>

                    <ListItemButton onClick={() => setStep(5)}>
                      <ListItemText primary="Animals" primaryTypographyProps={{ variant: 'h6' }}  ></ListItemText>
                      <ListItemSecondaryAction>{getSingleEmission(fullModel.animals.totalEmission)}</ListItemSecondaryAction>
                    </ListItemButton>

                    {/* <ListItemButton onClick={() => setStep(6)}>
                      <ListItemText primary="Soil" primaryTypographyProps={{ variant: 'h6' }}  ></ListItemText>
                      <ListItemSecondaryAction>{getSingleEmission(fullModel.soil.totalEmission)}</ListItemSecondaryAction>
                    </ListItemButton> */}

                    <ListItemButton onClick={() => setStep(6)}>
                      <ListItemText primary="Fuel & Energy" primaryTypographyProps={{ variant: 'h6' }}  ></ListItemText>
                      <ListItemSecondaryAction>{getSingleEmission(fullModel.fuel.totalEmission)}</ListItemSecondaryAction>
                    </ListItemButton>

                    <ListItemButton onClick={() => setStep(7)}>
                      <ListItemText primary="Irrigation" primaryTypographyProps={{ variant: 'h6' }}  ></ListItemText>
                      <ListItemSecondaryAction>{getSingleEmission(fullModel.irrigation.totalEmission)}</ListItemSecondaryAction>
                    </ListItemButton>


                  </List>
                </CardContent>
              </Card>
            </Grid>
            {loading && <Grid sx={{ mt: '40px' }} item xs={12} sm={8} textAlign="center"> <CircularProgress /> </Grid>}
            {!loading && <Grid item xs={12} sm={8}>
              {step === 1 && <FieldInformation parcels={parcels} nextStep={() => setStep(2)} updateModel={onUpdateFullModel} model={fullModel} setModel={setFullModel} />}
              {step === 2 && <ResiduesForm area={fullModel.area} year={fullModel.year} climateZone={fullModel.climateZone} nextStep={() => setStep(3)} prevStep={() => setStep(1)} model={fullModel.residues} setModel={(newModel) => setFullModel(current => ({ ...current, residues: { ...current.residues, ...newModel } }))} />}
              {step === 3 && <PesticidesForm area={fullModel.area}  year={fullModel.year} products={[
                {
                  "function": "I&N",
                  "active_substance": "1,3-dichloropropene",
                  "energy_used": 226.0
                },
                {
                  "function": "H",
                  "active_substance": "2-4D",
                  "energy_used": 107.0
                },
                {
                  "function": "I&N",
                  "active_substance": "Alpha-cypermethrin",
                  "energy_used": 518.0
                },
                {
                  "function": "H",
                  "active_substance": "Atrazine",
                  "energy_used": 208.0
                },
                {
                  "function": "F",
                  "active_substance": "Azoxystrobin",
                  "energy_used": 615.0
                },
                {
                  "function": "F",
                  "active_substance": "Boscalid",
                  "energy_used": 713.0
                },
                {
                  "function": "H",
                  "active_substance": "Bromoxynil",
                  "energy_used": 302.0
                },
                {
                  "function": "F",
                  "active_substance": "Carbendazim",
                  "energy_used": 410.0
                },
                {
                  "function": "H",
                  "active_substance": "Carbetamide",
                  "energy_used": 302.0
                },
                {
                  "function": "H&D",
                  "active_substance": "Chloridazon",
                  "energy_used": 291.0
                },
                {
                  "function": "GR",
                  "active_substance": "Chlormequat(+/-chloride)",
                  "energy_used": 270.0
                },
                {
                  "function": "F",
                  "active_substance": "Chlorothalonil",
                  "energy_used": 313.0
                },
                {
                  "function": "H&D",
                  "active_substance": "Chlorotoluron",
                  "energy_used": 367.0
                },
                {
                  "function": "H",
                  "active_substance": "Clopyralid",
                  "energy_used": 432.0
                },
                {
                  "function": "H&D",
                  "active_substance": "Cyanazine",
                  "energy_used": 221.0
                },
                {
                  "function": "F",
                  "active_substance": "Cymoxanil",
                  "energy_used": 442.0
                },
                {
                  "function": "Insecticide",
                  "active_substance": "Mix for potato",
                  "energy_used": 9.2603
                },
                {
                  "function": "F",
                  "active_substance": "Cyproconazole",
                  "energy_used": 551.0
                },
                {
                  "function": "F",
                  "active_substance": "Cyprodinil",
                  "energy_used": 637.0
                },
                {
                  "function": "H&D",
                  "active_substance": "Diquat",
                  "energy_used": 420.0
                },
                {
                  "function": "F",
                  "active_substance": "Epoxiconazole",
                  "energy_used": 626.0
                },
                {
                  "function": "GR",
                  "active_substance": "Ethephon",
                  "energy_used": 194.0
                },
                {
                  "function": "I&N",
                  "active_substance": "Ethoprophos",
                  "energy_used": 334.0
                },
                {
                  "function": "F",
                  "active_substance": "Fenpropimorph",
                  "energy_used": 475.0
                },
                {
                  "function": "H&D",
                  "active_substance": "Florasulam",
                  "energy_used": 691.0
                },
                {
                  "function": "F",
                  "active_substance": "Fluazinam",
                  "energy_used": 594.0
                },
                {
                  "function": "H&D",
                  "active_substance": "Flufenacet",
                  "energy_used": 648.0
                },
                {
                  "function": "F FST",
                  "active_substance": "Fluoxastrobin",
                  "energy_used": 637.0
                },
                {
                  "function": "F",
                  "active_substance": "Flusilazole",
                  "energy_used": 529.0
                },
                {
                  "function": "GR",
                  "active_substance": "Imazaquin",
                  "energy_used": 518.0
                },
                {
                  "function": "H&D",
                  "active_substance": "Iodosulfuron-methyl-sodium",
                  "energy_used": 691.0
                },
                {
                  "function": "F",
                  "active_substance": "Kresoxim-methyl",
                  "energy_used": 518.0
                },
                {
                  "function": "I&N",
                  "active_substance": "Lambda-cyhalothrin",
                  "energy_used": 529.0
                },
                {
                  "function": "H&D",
                  "active_substance": "Linuron",
                  "energy_used": 310.0
                },
                {
                  "function": "GR",
                  "active_substance": "Maleic hydrazide",
                  "energy_used": 151.0
                },
                {
                  "function": "F",
                  "active_substance": "Mancozeb",
                  "energy_used": 280.0
                },
                {
                  "function": "H&D",
                  "active_substance": "Mecoprop-P",
                  "energy_used": 194.0
                },
                {
                  "function": "H&D",
                  "active_substance": "Mesosulfuron-methyl",
                  "energy_used": 659.0
                },
                {
                  "function": "H",
                  "active_substance": "Mesotrione",
                  "energy_used": 691.0
                },
                {
                  "function": "F",
                  "active_substance": "Metalaxyl-M",
                  "energy_used": 659.0
                },
                {
                  "function": "H&D",
                  "active_substance": "Metamitron",
                  "energy_used": 432.0
                },
                {
                  "function": "H&D",
                  "active_substance": "Metazachlor",
                  "energy_used": 388.0
                },
                {
                  "function": "F",
                  "active_substance": "Metconazole",
                  "energy_used": 615.0
                },
                {
                  "function": "F",
                  "active_substance": "Metrafenone",
                  "energy_used": 713.0
                },
                {
                  "function": "H&D",
                  "active_substance": "Metsulfuron-methyl",
                  "energy_used": 518.0
                },
                {
                  "function": "H",
                  "active_substance": "Nicosulfuron",
                  "energy_used": 594.0
                },
                {
                  "function": "I&A&N",
                  "active_substance": "Oxamyl",
                  "energy_used": 345.0
                },
                {
                  "function": "H&D",
                  "active_substance": "Pendimethalin",
                  "energy_used": 421.0
                },
                {
                  "function": "H&D",
                  "active_substance": "Phenmedipham",
                  "energy_used": 345.0
                },
                {
                  "function": "F FST",
                  "active_substance": "Prochloraz",
                  "energy_used": 453.0
                },
                {
                  "function": "F",
                  "active_substance": "Propamocarb hydrocholoride",
                  "energy_used": 464.0
                },
                {
                  "function": "H&D",
                  "active_substance": "Propaquizafop",
                  "energy_used": 561.0
                },
                {
                  "function": "H&D",
                  "active_substance": "Propyzamide",
                  "energy_used": 410.0
                },
                {
                  "function": "H",
                  "active_substance": "Prosulfuron",
                  "energy_used": 626.0
                },
                {
                  "function": "F FST,FST",
                  "active_substance": "Prothioconazole",
                  "energy_used": 475.0
                },
                {
                  "function": "F",
                  "active_substance": "Pyraclostrobin",
                  "energy_used": 702.0
                },
                {
                  "function": "H&D",
                  "active_substance": "Simazine",
                  "energy_used": 226.0
                },
                {
                  "function": "F",
                  "active_substance": "Spiroxamine",
                  "energy_used": 669.0
                },
                {
                  "function": "S,F",
                  "active_substance": "Sulphur",
                  "energy_used": 0.0
                },
                {
                  "function": "SA",
                  "active_substance": "Sulphuric acid",
                  "energy_used": 0.0
                },
                {
                  "function": "I&N",
                  "active_substance": "Tau-fluvalinate",
                  "energy_used": 486.0
                },
                {
                  "function": "H&D,H",
                  "active_substance": "Thifensulfuron-methyl",
                  "energy_used": 540.0
                },
                {
                  "function": "H",
                  "active_substance": "Tri-allate",
                  "energy_used": 270.0
                },
                {
                  "function": "H&D",
                  "active_substance": "Tribenuron-methyl",
                  "energy_used": 540.0
                },
                {
                  "function": "H",
                  "active_substance": "Triclopyr",
                  "energy_used": 432.0
                },
                {
                  "function": "H",
                  "active_substance": "Trifloxystrobin",
                  "energy_used": 680.0
                },
                {
                  "function": "GR",
                  "active_substance": "Trinexapac-ethyl",
                  "energy_used": 583.0
                },
                {
                  "function": "I&N",
                  "active_substance": "Zeta-cypermethrin",
                  "energy_used": 615.0
                },
                {
                  "function": "H&D,H",
                  "active_substance": "Diflufenican",
                  "energy_used": 540.0
                },
                {
                  "function": "H&D,H",
                  "active_substance": "Ethofumesate",
                  "energy_used": 367.0
                },
                {
                  "function": "H&D,H",
                  "active_substance": "Fluroxypyr",
                  "energy_used": 518.0
                },
                {
                  "function": "H&D,H",
                  "active_substance": "Glyphosate",
                  "energy_used": 474.0
                },
                {
                  "function": "H&D,H",
                  "active_substance": "Isoproturon",
                  "energy_used": 378.0
                },
                {
                  "function": "H&D,H",
                  "active_substance": "MCPA",
                  "energy_used": 148.0
                },
                {
                  "function": "H&D,H",
                  "active_substance": "Trifluralin",
                  "energy_used": 171.0
                },
                {
                  "function": "F FST,FST",
                  "active_substance": "Tebuconazole",
                  "energy_used": 551.0
                },
                {
                  "function": "I&N,M&R",
                  "active_substance": "Metaldehyde",
                  "energy_used": 148.0
                },
                {
                  "function": "I&N,I",
                  "active_substance": "Chlorpyrifos",
                  "energy_used": 324.0
                },
                {
                  "function": "I&N,I",
                  "active_substance": "Cypermethrin",
                  "energy_used": 600.0
                }
              ]} nextStep={() => setStep(4)} prevStep={() => setStep(2)} model={fullModel.pesticides} setModel={(newModel) => setFullModel(current => ({ ...current, pesticides: { ...current.pesticides, ...newModel } }))} />}
              {/* {state.step === 2 && <FertiliserPesticides area={fullModel.area} prevStep={() => setState(current => ({ ...current, step: 1 }))} nextStep={() => setState(current => ({ ...current, step: 3 }))} fertiliserProduction={state.fertiliserProduction} nitrificationInhibitors={state.nitrificationInhibitors} directUsage={state.directUsage} globalWarming={state.globalWarming} model={fullModel} setModel={setFullModel} />}
          {state.step === 3 && <FuelConsumption fieldOperations={state.fieldOperations} area={fullModel.area} prevStep={() => setState(current => ({ ...current, step: 2 }))} nextStep={() => setState(current => ({ ...current, step: 4 }))} direct={state.directFuelFactors} estimated={state.estimatedFuelFactors} model={fullModel.fuel} setModel={updateFuelFullModel} />}
          {state.step === 4 && <IrrigationConsumption skip={fullModel.fuel.isDirect} countryCode={fullModel.country.country_code} country={fullModel.country.country} area={fullModel.area} prevStep={() => setState(current => ({ ...current, step: 3 }))} direct={state.directFuelFactors} nextStep={() => setState(current => ({ ...current, step: 5 }))} model={fullModel.irrigation} setModel={updateIrrigationFullModel} volumeOnly={state.irrigationFactors} />}
          {state.step === 5 && <Result isEdit={isEdit} model={fullModel} prevStep={() => setState(current => ({ ...current, step: 4 }))} direct={state.directFuelFactors} />} */}
              {step === 4 && <FertilizersForm area={fullModel.area} year={fullModel.year} climateZone={fullModel.climateZone} nextStep={() => setStep(5)} prevStep={() => setStep(3)} model={fullModel.fertilizers} setModel={(newModel) => setFullModel(current => ({ ...current, fertilizers: { ...current.fertilizers, ...newModel } }))} />}

              {step === 5 && <AnimalsForm year={fullModel.year} climateZone={fullModel.climateZone} nextStep={() => setStep(6)} prevStep={() => setStep(4)} model={fullModel.animals} setModel={(newModel) => setFullModel(current => ({ ...current, animals: { ...current.animals, ...newModel } }))} />}

              {/* {step === 6 && <SoilForm year={fullModel.year} climateZone={fullModel.climateZone} nextStep={() => setStep(7)} prevStep={() => setStep(5)} model={fullModel.soil} setModel={(newModel) => setFullModel(current => ({ ...current, soil: { ...current.soil, ...newModel } }))} />} */}
              {step === 6 && <FuelForm year={fullModel.year} area={fullModel.area} climateZone={fullModel.climateZone} nextStep={() => setStep(7)} prevStep={() => setStep(5)} model={fullModel.fuel} setModel={(newModel) => setFullModel(current => ({ ...current, fuel: { ...current.fuel, ...newModel } }))} />}
              {step === 7 && <IrrigationForm year={fullModel.year} area={fullModel.area} climateZone={fullModel.climateZone} nextStep={() => setStep(8)} prevStep={() => setStep(6)} model={fullModel.irrigation} setModel={(newModel) => setFullModel(current => ({ ...current, irrigation: { ...current.irrigation, ...newModel } }))} />}
              {step === 8 && <CarbonAssessmentResult id={props.id} isEdit={isEdit} model={fullModel} calculateTotal={getTotalEmission} prevStep={() => setStep(7)} />}

            </Grid>}
          </Grid>
        </Grid>


      </Grid>

    </Container>
  )

}

export default CarbonAssessmentInput;